var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamationCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "exclamation-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M40 5C20.6719 5 5 20.6719 5 40C5 59.3281 20.6719 75 40 75C59.3281 75 75 59.3281 75 40C75 20.6719 59.3281 5 40 5ZM37.5 23.125C37.5 22.7812 37.7812 22.5 38.125 22.5H41.875C42.2188 22.5 42.5 22.7812 42.5 23.125V44.375C42.5 44.7188 42.2188 45 41.875 45H38.125C37.7812 45 37.5 44.7188 37.5 44.375V23.125ZM40 57.5C39.0187 57.48 38.0843 57.0761 37.3974 56.375C36.7105 55.6739 36.3258 54.7315 36.3258 53.75C36.3258 52.7685 36.7105 51.8261 37.3974 51.125C38.0843 50.4239 39.0187 50.02 40 50C40.9813 50.02 41.9157 50.4239 42.6026 51.125C43.2895 51.8261 43.6742 52.7685 43.6742 53.75C43.6742 54.7315 43.2895 55.6739 42.6026 56.375C41.9157 57.0761 40.9813 57.48 40 57.5Z",
    fill: "#1890FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationCircle);
export default __webpack_public_path__ + "static/media/exclamation-circle.52955c9c689dc97a8a582349b7c3c58a.svg";
export { ForwardRef as ReactComponent };